import React from 'react'
import './ModalConfirmDelete.scss'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

interface ModalConfirmDeleteProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const ModalConfirmDelete: React.FC<ModalConfirmDeleteProps> = ({ show, onHide, onConfirm }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body>
        <div className="modal-confirm-delete-content">
          ¿Está seguro de eliminar el pago?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="none" className='form-button-cancel' onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="none" className='form-button-create' onClick={onConfirm}>
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalConfirmDelete